const API_URL = process.env.REACT_APP_API_URL;

export async function fetchData() {
    const response = await fetch(`${API_URL}/api/data`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431` 
        }
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
}

export async function fetchAssignedData(id) {
    const response = await fetch(`${API_URL}/api/assigneddata?id=${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431` 
        }
    });
    
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    
    return response.json();
}

export async function fetchUsers() {
    const response = await fetch(`${API_URL}/api/users`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431` 
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch user name');
    }

    return response.json();
}

export async function createIssue(issueData, attachments = []) { // Default attachments to an empty array
    const formData = new FormData();

    // Append issue data as a JSON string
    formData.append('issueData', JSON.stringify(issueData));

    // Ensure attachments is an array, then append each attachment file
    if (Array.isArray(attachments)) {
        attachments.forEach((attachment) => {
            formData.append('attachments', attachment);
        });
    }

    const response = await fetch(`${API_URL}/api/issue`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431`,
        },
        body: formData,
    });

    if (!response.ok) {
        throw new Error('Failed to create issue');
    }

    return response.json();
}


export async function updateIssue(updateData, deletedAttachments = [], newAttachments = [], previousAssignedUsers = []) {
    const formData = new FormData();

    // Append update data as a JSON string
    formData.append('updateData', JSON.stringify(updateData));

    // Append the previous assigned users as a JSON string.
    formData.append('previousAssignedUsers', JSON.stringify(previousAssignedUsers));

    // Ensure deletedAttachments is an array before appending
    if (Array.isArray(deletedAttachments)) {
        formData.append('deletedAttachments', JSON.stringify(deletedAttachments));
    } else {
        formData.append('deletedAttachments', JSON.stringify([])); // Fallback to an empty array
    }

    // Append each new attachment file if provided
    if (Array.isArray(newAttachments)) {
        newAttachments.forEach((attachment) => {
            formData.append('newAttachments', attachment);
        });
    }

    const response = await fetch(`${API_URL}/api/update`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431`
        },
        body: formData
    });

    if (!response.ok) {
        throw new Error('Failed to update issue');
    }

    return response.json();
}


export async function deleteIssue(issue) {
    const response = await fetch(`${API_URL}/api/delete`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431` 
        },
        body: JSON.stringify(issue), // Pass the issue data
    });

    if (!response.ok) {
        throw new Error('Failed to delete issue');
    }

    // Since the backend might return 204 No Content, handle it
    if (response.status === 204) {
        return { message: 'Issue successfully deleted' };
    }

    return response.json();
}

export async function getPreferences(id) {
    const response = await fetch(`${API_URL}/api/preferences?id=${encodeURIComponent(id)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431` 
        }
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
}

export async function setPreferences(id, preferences) {
    const response = await fetch(`${API_URL}/api/setpreferences`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431` 
        },
        body: JSON.stringify({ id, preferences }) 
    });

    if (!response.ok) {
        throw new Error('Failed to set preferences');
    }

    return response.json();
}

export async function getSasToken() {
    try {
        const response = await fetch(`${API_URL}/api/getSasToken`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer OIU^%^*&fdjHGFSDYUITFDA765765fsafasjhgew873SPMSPM4431`,
            },
        });
        
        if (!response.ok) {
            throw new Error('Failed to fetch SAS token');
        }
        
        const data = await response.json();
        return {
            sasToken: data.sasToken,
            expiresOn: data.expiresOn
        };
        
    } catch (error) {
        console.error('Error fetching SAS token:', error);
        throw error; // Rethrow error to handle it in calling code
    }
}
